import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import Public from "../../Layouts/Public";
import PersonalAppFeatures from "../../components/AppFeatures/PersonalAppFeatures";
import Button from "../../components/Button/Button";
import FeatureRow from "../../components/FeatureRow";
import HeroSection, {
  HeroH2,
  HeroH3,
  HeroTitle,
} from "../../components/HeroSection";
import FillerImage from "../../components/Images/FillerImage";
import PageSection, {
  StyledSectionHeading,
} from "../../components/PageSection";
import Spacer from "../../components/Spacer";
import { siteTitle } from "../../data/PublicSiteData";
import { trackPageView } from "../../includes/analytics";
import { Color } from "../../theme/Color";

const LocalAmeego = () => {
  const router = useRouter();

  const heroImage = (
    <img
      src={`/img/app-screenshots/choose-an-ameego-19042501.webp`}
      alt="Valmeego.com - Locally and beyond"
      style={{ width: "100%", maxWidth: "338px", height: "auto" }}
    />
  );

  trackPageView("/ameegos/local");

  return (
    <>
      <NextSeo
        title={`Local Ameego | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />
      <HeroSection
        background={`/img/header-backgrounds/local-ameego.png`}
        backgroundOverlayOpacity={0.5}
        image={heroImage}
      >
        <Row center="xs">
          <Col xs={10} sm={10} md={10} lg={12}>
            <Row>
              <HeroTitle>
                Provide knowledge of your local area to help visitors.
              </HeroTitle>
            </Row>
            <Row>
              <HeroH2>
                A “local” Ameego has the in-depth knowledge to provide a user
                with personalised recommendations and guidance for everything in
                their locality. They have the local’s answers to all those
                little, important questions that make things so much easier for
                a visitor.
              </HeroH2>
            </Row>
            <Row>
              <HeroH3>
                Help users truly experience your locality, find hidden gems,
                services, and activities of particular interest to them. Open up
                the possibility of earning some additional income from your
                knowledge.
              </HeroH3>
            </Row>
            <Row>
              <Col xs={12}>
                <Button
                  dataCy="hero-signup-button"
                  color="primary"
                  label="Sign up"
                  size="extra-large"
                  onClick={() => {
                    router.push("/personal/register");
                  }}
                />
                <Row center="xs">Valmeego is free to join and use</Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </HeroSection>
      {/* Features */}
      <PageSection id="features">
        <Spacer top={4} bottom={10}>
          <Row center="xs" middle="xs">
            <StyledSectionHeading>Benefits</StyledSectionHeading>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={8} style={{ color: Color.Grey2 }}>
              <FeatureRow title="Monetize Your Expertise/ Knowledge: ">
                Transform your passion for travel into a lucrative side hustle
                by earning additional income for sharing your knowledge and
                recommendations. Earn additional income while doing what you
                love!
              </FeatureRow>
              <FeatureRow title="Professional Networking Opportunities:">
                Connect with fellow travel advisors, industry experts, and local
                businesses. Expand your professional network and opportunities
                for collaboration.
              </FeatureRow>
              <FeatureRow title="Establish Your Reputation: ">
                Position yourself as a trusted expert and influencer within the
                travel community. Gain recognition and credibility for your
                knowledge and contributions.
              </FeatureRow>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Row center="xs">
                <Spacer top={3} right={1} bottom={3} left={1}>
                  <FillerImage
                    src={`/img/content/local-helping.webp`}
                    alt="Valmeego.com - Locally and beyond"
                    width={265}
                    height={348}
                  />
                </Spacer>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={false} sm={6} md={3}>
              <Row>
                <Spacer top={3} right={1} bottom={1} left={1}>
                  <FillerImage
                    src={`/img/content/local-ameego-reception.webp`}
                    alt="Valmeego.com - Locally and beyond"
                    width={265}
                    height={348}
                  />
                </Spacer>
              </Row>
            </Col>
            <Col xs={12} sm={6} md={8} style={{ color: Color.Grey2 }}>
              <FeatureRow title="Increase Your Reach:">
                Gain exposure to a global audience of travellers actively
                seeking personalized recommendations and guidance for their
                trips.
              </FeatureRow>
              <FeatureRow title="Be the first to know what’s on:">
                Stay ahead with Valmeego's social Feeds for all travel-related
                information, from local updates to hidden gems around the world.
              </FeatureRow>
              <FeatureRow title="Enrich the Visitor Experience:">
                Your insights and recommendations help travellers discover the
                richness and authenticity of your locality. Foster positive
                experiences while driving economic growth within your community.
              </FeatureRow>
            </Col>
            <Col xs={8} xsOffset={2} sm={false}>
              <Button
                color="primary"
                label="Sign up"
                size="extra-large"
                onClick={() => {
                  router.push("/personal/register");
                }}
              />
              <Row center="xs" style={{ color: Color.Grey2 }}>
                Valmeego is free to join and use
              </Row>
            </Col>
          </Row>
        </Spacer>
      </PageSection>
      <PersonalAppFeatures />
    </>
  );
};

LocalAmeego.Layout = Public;
LocalAmeego.Title = "Valmeego - Locally and beyond";

export default LocalAmeego;
